import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_994_6126",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_994_6126)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M5 18.9424H6.2615L16.498 8.70588L15.2365 7.44438L5 17.6809V18.9424ZM3.5 20.4424V17.0579L16.6905 3.87313C16.8417 3.7358 17.0086 3.62972 17.1913 3.55488C17.3741 3.47988 17.5658 3.44238 17.7663 3.44238C17.9668 3.44238 18.1609 3.47797 18.3488 3.54913C18.5367 3.6203 18.7032 3.73347 18.848 3.88863L20.0693 5.12513C20.2244 5.26997 20.335 5.43663 20.401 5.62513C20.467 5.81363 20.5 6.00213 20.5 6.19063C20.5 6.3918 20.4657 6.58372 20.397 6.76638C20.3283 6.94922 20.2191 7.11622 20.0693 7.26738L6.8845 20.4424H3.5ZM15.8562 8.08613L15.2365 7.44438L16.498 8.70588L15.8562 8.08613Z",
			fill: "currentColor"
		})
	})]
});
export default SvgEdit;
